export const EDIT_BLOCK = "EDIT_BLOCK"
export const EDIT_BLOCK_CHANGE_TEXT = "EDIT_BLOCK_CHANGE_TEXT"
export const EDIT_BLOCK_SUCCESS = "EDIT_BLOCK_SUCCESS"
export const EDIT_BLOCK_CLEAN = "EDIT_BLOCK_CLEAN"
export const EDIT_BLOCK_ERROR = "EDIT_BLOCK_ERROR"
